import React, { useEffect, useRef, useState }   from "react";
import {Link}                           from "react-router-dom";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";

import "./order.scss";

import {deletePendingItem, checkoutOrder}  from "@Xpresso/routes/account/orders/pending-route/orders-table/orders-table"
import {Shimmer}            from "../../../common/shimmer/shimmer";
import {DesktopActions}     from "@Xpresso/routes/account/orders/common/order-actions/desktop-actions";
import {makeItemAsActionsMap, ScheduledCampaignsTooltip} from "@Xpresso/routes/account/orders/common/order-actions/item-actions";
import {PROGRAM_TYPE}          from "@Xpresso/routes/common/logic/program";
import {URL_ORDERS_HISTORY} from "../orders";
import {scrollToTop}        from "@Xpresso/routes/omni-search/omni-search-layout/common/common.js"

export const WIDTH_ORDER = 350

export const Order = ({
    item, 
    items,
    addSearchHistoryRecord,
    apis,
    cart,
    company,
    routerHistory,
    session,
    setOrdersPending,
    deleteTargetOrder,
    setDeleteTargetOrder
}) => {
    const order = item

    const [thumbnailLoaded, setThumbnailLoaded] = useState(false)
    const deletionPending = deleteTargetOrder === order.idOrder

    const hasThumbnails = Array.isArray(order.itemThumbnails) && order.itemThumbnails.length > 0
    const thumbnails = hasThumbnails ? JSON.parse(order.itemThumbnails) : []
    const isPendingOrder = order.status.includes('pending')
    const nameFirst = order.agentNameFirst ?? ''
    const nameLast = order.agentNameLast ?? ''
    const nameOffice = order.branchName ?? ''

    const handleDeleteItem = () => {
        const itemId = order.idOrder
        const deleteItem = () => {
            const pending = items.filter(item => item.idOrder !== order.idOrder)
            setOrdersPending(pending)
        }
        deletePendingItem({apis, itemId, onDeleted: deleteItem})
    }

    const visibilityDelete = deletionPending ? 'visible' : 'hidden'
    const visibilityContent = deletionPending ? 'hidden' : 'visible'  
    
    return (
        <div className="order-765abc">
           <div className={`confirm-delete ${visibilityDelete}`}>
                <div className="messages">
                    <div className="header">Delete Pending Order</div>
                    <div className="sub-header">Are you sure you wish to proceed?</div>
                </div>
                <div className="controls">
                    <button 
                        className="cancel"
                        onClick={(e) => {
                            e.stopPropagation()
                            setDeleteTargetOrder(null)
                        }}
                    >
                        Cancel
                    </button>
                    <button 
                        className="confirm"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleDeleteItem()
                        }}
                    >
                        Yes
                    </button>
                </div>
            </div>
            {!thumbnailLoaded && <Shimmer name={`image-container ${visibilityContent}`} />}      
            <div 
                className={`image-container ${visibilityContent}`}
                style={{display: thumbnailLoaded ? 'flex' : 'none'}}
            >
                <img 
                    src={thumbnails[0]} 
                    alt={`image-${order.id}`}
                    onLoad={() => setThumbnailLoaded(true)}
                />
            </div>
            <div className={`details ${visibilityContent}`}>
                <div className="generals">
                    <p className="order-id">
                        {`Order ID ${order.idOrder}`}
                    </p>
                    <p className="order-name">
                        {`${order.itemName}`}
                    </p>
                </div>
                <div className="specifics">
                    <div className="specific">
                        <p className="header">
                            Name
                        </p>
                        <p className="agent-name">
                            {`${nameFirst} ${nameLast}`}
                        </p>
                    </div>
                    <div className="specific">
                        <p className="header">
                            Office
                        </p>
                        <p className="office-name">
                            {`${nameOffice}`}
                        </p>
                    </div>
                </div>
                <div className="controls">
                {
                    isPendingOrder 
                    ? <OrderControls {...{order, items, apis, cart, company, routerHistory, session, setOrdersPending, setDeleteTargetOrder}} />
                    : <Link
                        to={`${URL_ORDERS_HISTORY}?orderId=${order.idOrder}`}
                        className="order-id-link"
                        onClick={() => {
                            addSearchHistoryRecord({
                                search_handler: "orders",
                                suggestion_data: order.idOrder, 
                                suggestion_name: order.itemName,
                                suggestion_type: "orderHistory",
                            })
                            scrollToTop()
                        }}
                    >
                        View Order
                    </Link>
                }
                </div>
            </div>
        </div>
    )
}

const OrderControls = ({order, items, apis, cart, company, routerHistory, session, setOrdersPending, setDeleteTargetOrder}) => {
    const mapItemAsActions = ({item}) => {
        if(!item) {
            return []
        }

        if(!cart) {
            return []
        }

        const sessionCart = cart?.value ?? null
        if(item.idOrder) {
            item.orderId = item.idOrder
        }
    
        return makeItemAsActionsMap({apis, session, sessionCart, company, routerHistory})({item});
    }
    const actions = mapItemAsActions({item: order})

    const handleCheckoutItem = () => {
        checkoutOrder({order, session, routerHistory})
    }

    const canNavigateToCart = order.idCart && !order.legacyOrder

    return (
        <div className="order-controls">
            {
                <div className="actions">
                    <DesktopActions
                        actions={actions}
                        footer={
                            order.programType === PROGRAM_TYPE.SCHEDULED_CAMPAIGNS &&
                            <ScheduledCampaignsTooltip/>
                        }
                    />
                </div>
            }
            <div className={`icons${canNavigateToCart ? '' : ' align-end'}`}>
                {
                    canNavigateToCart &&
                    <FontAwesomeIcon
                        icon={require('@fortawesome/free-solid-svg-icons')['faCartShopping']}
                        className='icon'
                        onClick={(e) => {
                            e.stopPropagation()
                            handleCheckoutItem()
                        }}
                        xd-qa-type="button"
                        xd-qa-name="cart"
                    />
                }
                <FontAwesomeIcon
                    icon={require('@fortawesome/free-solid-svg-icons')['faTrash']}
                    className='icon trash'
                    onClick={(e) => {
                        e.stopPropagation()
                        setDeleteTargetOrder(order.idOrder)
                    }}
                    xd-qa-type="button"
                    xd-qa-name="delete order"
                />
            </div>
        </div>
    )
}